module.exports = __webpack_public_path__ + "img/mobile_keyboard_light.5023f0ff.png";